import React from "react";
import { IMAGES } from "@/lib/site";

const items = [IMAGES.hero, IMAGES.cabin, IMAGES.lake, IMAGES.trail, IMAGES.caravan];

const Gallery = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 md:py-36 bg-[#F5EFE6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-6">
            <p className="overline text-[#6A5F58]">
              <span className="marker-line" />
              Postcards
            </p>
            <h2 className="font-serif text-4xl md:text-5xl mt-6 text-[#14100F] leading-[1.05]">
              What it looks like when the kettle’s on.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-6 gap-4 md:gap-5" data-testid="gallery-grid">
          <div className="col-span-6 md:col-span-4 img-frame aspect-[16/10]">
            <img src={items[0]} alt="Lake at sunrise" />
          </div>
          <div className="col-span-3 md:col-span-2 img-frame aspect-[4/5]">
            <img src={items[1]} alt="Log cabin" />
          </div>
          <div className="col-span-3 md:col-span-2 img-frame aspect-[4/5]">
            <img src={items[4]} alt="Caravan pitch" />
          </div>
          <div className="col-span-6 md:col-span-2 img-frame aspect-[4/5]">
            <img src={items[3]} alt="Trail" />
          </div>
          <div className="col-span-6 md:col-span-2 img-frame aspect-[4/5]">
            <img src={items[2]} alt="Fishing lake" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
